<template>
  <!-- Transaction Data Example -->
  <div class="d-flex align-items-center">
    <p class="mb-0" style="cursor: pointer" @click="handleTrsxnSelection">
      <IconSquareCheck
        v-if="txn?._selected === true"
        size="20"
        class="text-success"
      />
      <IconSquare v-else size="20" />
    </p>
    <div
      class="px-1 py-1 mx-1 my-1 border rounded"
      :style="
        txn.snapshot_categories
          ? 'background-color: #e9ecef; border-color: #ced4da;'
          : 'background-color: white;'
      "
      style="border: 2px solid black"
    >
      <strong :class="txn.amount < 0 ? 'text-danger' : 'text-success'">{{
        formatCurrencyDollarSign(txn.amount)
      }}</strong>
      {{ txn.description }} on
      {{ txn.date }}
      <BBadge variant="dark">{{ txn.institution_name }}</BBadge>
    </div>
    <p class="mb-0">
      <IconClipboardText
        size="20"
        class="ms-2"
        :class="txn?.note ? 'text-info' : 'text-muted'"
        style="cursor: pointer"
        v-b-tooltip.hover
        :title="`${txn?.note}`"
      />
    </p>
  </div>
</template>
<script>
import numberFormatMixin from "@/mixins/numberFormatMixin";
import {
  IconClipboardText,
  IconSquareCheck,
  IconSquare,
} from "@tabler/icons-vue";
import { BBadge, vBTooltip } from "bootstrap-vue-next";

export default {
  name: "TrsxnsLoaderListItemView",
  props: {
    txn: {
      type: Object,
      required: true,
    },
  },
  directives: {
    BTooltip: vBTooltip,
  },
  emits: ["transactionSelected"],
  mixins: [numberFormatMixin],
  components: {
    BBadge,
    IconClipboardText,
    IconSquareCheck,
    IconSquare,
  },
  data() {
    return {};
  },
  methods: {
    handleTrsxnSelection() {
      this.$emit("transactionSelected", this.txn);
    },
  },
};
</script>
